import { formatNumber } from 'core/service/lib/number-format'
import { getLifeProtectBenefitData, isLifeProtectProduct } from 'core/service/basic-plan/benefit'
import Mustache from 'mustache'
import MESSAGES from 'core/data-model/constants/bi-messages'

const LifeProtect18ProductBenefits = ({ displayProduct, sumAssured }) => {
  if (!isLifeProtectProduct(displayProduct.basicPlanCode)) return null

  const benefitData = getLifeProtectBenefitData()
  const untilAge = displayProduct.paymentPeriod.type === 'limited_to_age' ? MESSAGES.UNTIL_AGE : ''
  return (
    <div id="product-benefits-content">
      <p>
        <b>{MESSAGES.BASIC_PLAN_BENEFITS}</b>
      </p>
      <ol id="benefit-list">
        <li>
          {Mustache.render(benefitData.paidAndCoveragePeriod, {
            untilAge: untilAge,
            paymentPeriod: displayProduct.paymentPeriod.value,
            coveragePeriod: displayProduct.coveragePeriod.value,
          })}
        </li>
        <li>{benefitData.coverageAmountDetails}</li>
        <li>
          {Mustache.render(benefitData.maturityDetails, {
            coveragePeriod: displayProduct.coveragePeriod.value,
          })}
        </li>
      </ol>
      <p>
        <b>{benefitData.beneficiaryBenefits}</b>
      </p>
      <div className="info-pair" id="death-benefit">
        <p className="description" id="death-benefit-sum-assured">
          {Mustache.render(benefitData.minimumAmountReceivedByBeneficiaries, { sumAssured: formatNumber(sumAssured) })}
          <br />
          {benefitData.coverageDetails}
        </p>
      </div>
    </div>
  )
}

export default LifeProtect18ProductBenefits
